// OAuth config
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET || "";
export const REDIRECT_URI =
  process.env.REACT_APP_REDIRECT_URI || `${window.location.origin}/oauth/authorized`;
export const SCOPES = ["ViewFiles", "ModifyFiles"];
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
export const PIPEDRIVE_CLIENT_ID = process.env.REACT_APP_PIPEDRIVE_CLIENT_ID || "";
export const PIPEDRIVE_SCOPE = process.env.REACT_APP_PIPEDRIVE_SCOPE || "";
export const IFTTT_SCOPE = process.env.REACT_APP_IFTTT_SCOPE || "";
export const SUPABASE_SCOPE = process.env.REACT_APP_SUPABASE_SCOPE || "";
